// Updates the "rest te betalen" amount in the Depo aanbetaling explainer card
// (rendered by snippets/buy-buttons.liquid) when the shopper picks a different
// variant, using the theme's existing variant-change pub/sub event.
(function () {
  function formatEUR(cents) {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function updateRest(root, priceCents) {
    var restEl = root.querySelector('[data-depo-explainer-rest]');
    if (!restEl) return;
    var depositCents = parseInt(root.dataset.depositCents, 10) || 0;
    restEl.textContent = formatEUR(priceCents - depositCents);
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  document.querySelectorAll('[data-depo-explainer]').forEach(function (root) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (variant && typeof variant.price === 'number') {
        updateRest(root, variant.price);
      }
    });
  });
})();
